import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { RecordModel, CustomerModel } from '../../../domain/models'
import {
  fetchCustomer,
  fetchRecord,
  resetReport,
  saveRecord,
  updateRecord
} from '../../../main/usecases'

import { maskCpf, formatDate } from '../../utils'
import { useModalBox, useOnChangeDetect } from '../../contexts'
import {
  Button,
  EditorCard,
  ResetModal,
  ServicesHeader,
  SubHeader
} from '../../components'

import {
  IconSaveSvg,
  IconReturnSvg,
  PrinterSvg
} from '../../assets/icons/svgComponents'

import * as S from './styles'

const Record = ({ match }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [record, setRecord] = useState<RecordModel>()
  const [recordData, setRecordData] = useState('')
  const [loading, setLoading] = useState(false)
  const alert = useAlert()
  const { refresh, setRefresh } = useOnChangeDetect()
  const { modalBox } = useModalBox()
  const [resetLoading, setResetLoading] = useState(false)

  const handleOpenResetModal = () => {
    modalBox(
      <ResetModal
        id={match?.params?.idassessment}
        loading={resetLoading}
        resetDocument={resetReport}
        setDocument={setRecord}
        setDocumentData={setRecordData}
        document="atestado"
      />,
      'Resetar Relatório',
      '32%'
    )
  }
  const onSaveReport = async () => {
    const body = {
      ...(record?.cdRelatorio && {
        cdRelatorio: record?.cdRelatorio
      }),
      relatorio: recordData
    }

    try {
      setResetLoading(true)
      if (record?.cdRelatorio) {
        await updateRecord({
          id: match?.params?.idassessment
        }).update(body)
        setRefresh((prev: any) => !prev)
      } else {
        await saveRecord({
          id: match?.params?.idassessment
        }).post(body)
        setRefresh((prev: any) => !prev)
      }
      setResetLoading(false)
    } catch (error) {
      console.error(error)
    }
  }

  const handlePrinter = async () => {
    const body = {
      ...(record?.cdRelatorio && {
        cdRelatorio: record?.cdRelatorio
      }),
      relatorio: recordData
    }

    try {
      if (record?.cdRelatorio) {
        await updateRecord({
          id: match?.params?.idassessment
        }).update(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      } else {
        await saveRecord({
          id: match?.params?.idassessment
        }).post(body)
        document
          ?.querySelectorAll('[style="display: block !important;"]')[0]
          ?.setAttribute('style', 'display:none !important;')
        window.print()
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    window.onafterprint = function () {
      document
        ?.querySelectorAll('[style="display:none !important;"]')[0]
        ?.setAttribute('style', 'display: block !important;')
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseRecord = await fetchRecord({
          id: match?.params?.idassessment
        }).load()
        setCustomer(responseCustomer)
        setRecord(responseRecord)
        setRecordData(responseRecord?.relatorio)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match.params.id, match?.params?.idassessment, refresh])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = {
      ...(record?.cdRelatorio && {
        cdAtestado: record?.cdRelatorio
      }),
      relatorio: recordData
    }

    try {
      setResetLoading(true)
      setLoading(true)
      if (record?.cdRelatorio) {
        await updateRecord({
          id: match?.params?.idassessment
        }).update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      } else {
        await saveRecord({
          id: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Error ao salvar/atualizar o Relatorio', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setTimeout(() => {
        setResetLoading(false)
        setLoading(false)
      }, 1500)
    }
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match.params.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          title="Relatório"
          hasPrinter
          disabled={loading}
          onPrinter={handlePrinter}
        />
        <EditorCard
          docType="relatorio"
          data={record && record?.relatorio}
          setData={setRecordData}
          title=""
          height="auto"
          hasReset
          openResetModal={() => {
            onSaveReport()
            handleOpenResetModal()
          }}
        />
        <S.ButtonsContainer className="no-print">
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            disabled={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>
          <Button
            initialIcon={<PrinterSvg />}
            className="button-printer"
            onClick={handlePrinter}
          >
            Imprimir
          </Button>
          <Button
            initialIcon={<IconReturnSvg />}
            hasSecodaryButton
            className="button-return-to-list"
          >
            <Link to={`/meus-pacientes/${match?.params?.id}/prontuario`}>
              Retornar à listagem
            </Link>
          </Button>

          {record?.dataUltimaModificacao && (
            <p>
              Data da última atualização:{' '}
              {formatDate(record?.dataUltimaModificacao || '')}
            </p>
          )}
        </S.ButtonsContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Record
